import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { salarySubNavItems } from './nav';

// Desktop / tablet in-page sub-navigation. On phones this is hidden (see
// .salary-subnav-wrap in PortalLayout.css) and the same items render in the
// fixed bottom bar driven by the module registry.
const SalarySubNav: React.FC = () => (
  <div className="salary-subnav-wrap">
    <div style={{ marginBottom: '0.85rem' }}>
      <Link to="/" className="sal-back"><span className="home" aria-hidden>⌂</span> Back to app</Link>
    </div>
    <nav className="salary-subnav">
      {salarySubNavItems.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.end}
          className={({ isActive }) => (isActive ? 'active' : '')}
        >
          {it.label}
        </NavLink>
      ))}
    </nav>
  </div>
);

export default SalarySubNav;
